import { AuthService} from './auth.service';
import { AccountService } from './account.service';
import { Injector } from '@angular/core';
import { Amplify } from 'aws-amplify';
import { PublicConfigStore } from '../public-config.store';

const amplifyInitializerFn = (store: PublicConfigStore) => {
    return store
        .getData()
        .toPromise()
        .then((config: any) => {
            Amplify.configure(config.amplify);
            console.log('AMPLIFY INITIALIZED!!!');
        });
};

export const AUTH_STARTUP = (
    configStore: PublicConfigStore,
    inj: Injector) => () => {

    console.log('AUTH STARTUP 1');
    return amplifyInitializerFn(configStore)
        .then(async () => {
            const auth = inj.get(AuthService);
            await auth.init();
            if (!auth.loggedUser.value.authenticated) {
                return;
            }

            const account = inj.get(AccountService);
            const user = await account.loadCurrentUser();
            auth.applyAccount(user);
        });
};
